<article class="entity-threat-details">
  <div class="section-header">
    <h4 class="descriptor h4">Threat Actor</h4>

    <div class="section-header-title-section">
      <div class="actor-title-and-section-actions">
        <div class="actor-title-and-buttons">
          <h1 class="title h1-medium">
            @if (this.incidentsPageStore.incident()!.actor) {
              {{ this.incidentsPageStore.incident()!.actor?.name }}
            } @else {
              Unknown
            }
          </h1>
          @if (this.incidentsPageStore.isEditMode()) {
            <div class="section-header-action-buttons">
              <button
                class="button-secondary-icon"
                mat-icon-button
                disableRipple
                [disabled]="!this.incidentsPageStore.incident()!.actor"
                (click)="onRemoveActor()"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button class="button-secondary" mat-flat-button extended (click)="openActorEdit()">Change actor</button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="cards-container">
    <mat-card class="mat-card section-info-card">
      <mat-card-title>Actor Type</mat-card-title>
      <mat-card-content>{{
        actorTypeHR[this.incidentsPageStore.incident()!.actor?.type || '-'] || '-'
      }}</mat-card-content>
    </mat-card>

    <mat-card class="mat-card section-info-card">
      <mat-card-title>Profile Link</mat-card-title>
      <mat-card-content>
        @if (!this.incidentsPageStore.incident()!.actor?.profileLink) {
          -
        } @else {
          <a [href]="this.incidentsPageStore.incident()!.actor?.profileLink" target="_blank" rel="noopener">{{
            this.incidentsPageStore.incident()!.actor?.profileLink
          }}</a>
        }
      </mat-card-content>
    </mat-card>
  </div>
</article>
